import React from 'react';
// Components
import AthleteSalesReportTable from 'components/common/AthleteSalesReportTable/AthleteSalesReportTable';

const AthleteSalesReport = (): JSX.Element => {
  return <AthleteSalesReportTable />;
};

export default AthleteSalesReport;
